import React from "react";
import { Trans } from "react-i18next";

const ImageModal = ({ image, showImage, closeImage }) => {
    return (
        <div
            className={`modal small-scroll-y ${
                image && showImage ? "show" : ""
            }`}
            id="uploaded-img-box"
        >
            <div className="modal-content-wrapper small-scroll-y sm-md-modal shadow">
                <div className="modal-content">
                    <div className="card-table shadow img-uploader flex items-center">
                        <img
                            src={
                                image ||
                                require("../../assets/images/Group 709.png")
                                    .default
                            }
                            className="uploaded-img-after"
                            alt="img-preview"
                        />
                    </div>
                </div>
                <div className="modal-footer">
                    <div className="modal-btn-actions-area flex items-center justify-end">
                        <button
                            className="default-transparent-btn modal-btn-close mr-2"
                            data-modal-close="uploaded-img-box"
                            onClick={() => closeImage(false)}
                        >
                            <Trans i18nKey="cancel">Cancel</Trans>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ImageModal;
